import GeofenceMessage from '@/_interfaces/GeofenceMessage'
import UserModel from '@/_models/UserModel'
import { cloneDeep } from 'lodash'
import moment from 'moment-timezone'

export const showUserChangeLocation = (
  messages: GeofenceMessage[],
  isDestroyed: boolean,
  cardOffAfterMins: number,
  userList: UserModel[]
) => {
  if (isDestroyed || !userList.length) {
    return []
  }

  const usersChanged: GeofenceMessage[] = []
  let vmMessages = cloneDeep(messages)
  for (const user of userList) {
    if (!user.measureded_at || user.geo_status === null) {
      continue
    }

    // Only check User have Enter/Exit if the measureded_at isn't larger than isRecentlyTime
    vmMessages = vmMessages.filter(msg => msg._id !== user._id)
    if (isOverTimeShowMessage(cardOffAfterMins, user.measureded_at)) {
      continue
    }

    usersChanged.push(convertUser(user, user.geo_status))
  }

  return sortMessages(usersChanged, vmMessages)
}

export const showUserChangeMultipleGeofence = (
  userList: UserModel[],
  cardOffAfterMins: number,
  geofencesGroup: any,
  messages: GeofenceMessage[]
) => {
  const usersChanged: GeofenceMessage[] = []
  let vmMessages = cloneDeep(messages)
  for (const user of userList) {
    const userGeoData = geofencesGroup[user._id]
    if (!user.measureded_at || !user.geo_ids || !userGeoData) {
      continue
    }

    // Only check User have Enter/Exit if the measureded_at isn't larger than isRecentlyTime
    vmMessages = vmMessages.filter(msg => msg._id !== user._id)
    if (isOverTimeShowMessage(cardOffAfterMins, user.measureded_at)) {
      // clear message is over time
      vmMessages = vmMessages.filter(msg => msg._id === user._id)
      continue
    }

    const isEnter = user.geo_ids?.length > 0
    let geoData = isEnter
      ? userGeoData.find(data => data.geo_id === user.geo_ids[0])
      : vmMessages.find(msg => msg._id === user._id)

    /*
      - In case user is in multiple geofence
        but the status is out of the location
        and can not find in the out message
      -> Using the first info as default
    */
    if (!geoData) {
      geoData = userGeoData[0]
    }
    usersChanged.push(
      convertUser(
        {
          ...user,
          geo_name: geoData.geo_name,
          geo_bg_class: isEnter ? geoData.bg_card_enter : geoData.bg_card_exit,
        },
        isEnter,
        geoData.geo_id
      )
    )
  }

  return sortMessages(usersChanged, vmMessages)
}

const convertDate = (time: any) => new Date(time)

const convertUser = (user: UserModel, isEnter: boolean, geofenceId: string = '') => {
  return {
    _id: user._id,
    u_name: user.name,
    geo_name: user.geo_name || '',
    geo_id: geofenceId || '',
    is_enter: isEnter,
    geo_bg_class: user.geo_bg_class || (isEnter ? 'success' : 'danger'),
    measureded_at: user.measureded_at || new Date(),
  } as GeofenceMessage
}

const isOverTimeShowMessage = (cardOffAfterMins: number, measuredAt: string | Date) => {
  const maxTimeShowUpCard = cardOffAfterMins > 5 ? cardOffAfterMins : 5
  const latestMeasuredToCurrent = moment.duration(moment().diff(moment(measuredAt))).asMinutes()

  // Card hidden when the period of the latest measured to current time is larger than time show card
  return latestMeasuredToCurrent > maxTimeShowUpCard
}

const sortMessages = (newMessage: GeofenceMessage[], oldMessage: GeofenceMessage[]) => {
  return newMessage
    .sort((a, b) => convertDate(b.measureded_at).getTime() - convertDate(a.measureded_at).getTime())
    .concat(oldMessage)
}
